function accordion(el) {
  const thisContent = el.parentNode.querySelector('.accordion-content')
  const heading = el.parentNode.querySelector('.menu__heading')
  
  if(thisContent.hasAttribute('open')) {
    thisContent.style.maxHeight = '0px'
    heading.style.marginBottom = '0px'
    thisContent.removeAttribute('open')
    el.removeAttribute('open')
  } else {
    thisContent.style.maxHeight = '400px'
    heading.style.marginBottom = '20px'
    thisContent.setAttribute('open', true)
    el.setAttribute('open', true)
  }
}

function closeMegaMenu(el, close) {
 el.closest(close).querySelector('.close-dropdown').click() 
}
